<template>
  <v-app id="inspire">
    <v-navigation-drawer
      v-model="drawer"
      app
      clipped
    >
      <v-list dense>
        <v-list-item
          v-for="item in items"
          :key="item.text"
          :to="typeof item.to !== 'undefined' ? { name: item.to, params: { lang: $i18n.locale } } : undefined"
          :href="typeof item.href !== 'undefined' ? item.href : undefined"
          exact
        >
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t(item.text) }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar
      id="app-toolbar"
      app
      clipped-left
      fixed
    >
      <v-app-bar-nav-icon
        :aria-label="$t('app.showHideMenu')"
        @click.stop="drawer = !drawer"
      />
      <router-link
        :to="{ name: 'home', params: { lang: $i18n.locale } }"
        :aria-label="$t('app.navigateToHomepage')"
      >
        <v-img
          v-if="TERYT"
          :src="require(`@/assets/img/coa/svg/${TERYT}.svg`)"
          :alt="$t('app.coa')"
          contain
          transition="scale-transition"
          height="42px"
          width="42px"
        />
      </router-link>
      <v-toolbar-title class="mr-12 align-center">
        <span class="title hidden-xs-only">{{ $t('app.title') }}</span>
        <span class="title hidden-sm-and-up">Geoportal</span>
      </v-toolbar-title>
      <v-spacer />
      <v-toolbar-items>
        <v-btn
          :aria-label="$t('app.geoportal2URL')"
          class="hidden-xs-only"
          href="https://www.geoportal2.pl"
          text
        >
          <v-img
            :src="require(`@/assets/img/logoGeoportal2.svg`)"
            :alt="$t('app.coa')"
            contain
            transition="scale-transition"
            height="28px"
            width="28px"
          />
        </v-btn>
        <v-btn
          :aria-label="$t('app.welcomeVoiceAria')"
          class="hidden-xs-only"
          text
          @click="playWelcome"
        >
          <v-icon>
            mdi-volume-high
          </v-icon>
        </v-btn>
        <v-menu
          transition="slide-y-transition"
          left
          bottom
          offset-y
          attach="attach"
        >
          <template v-slot:activator="{ on }">
            <v-btn
              :aria-label="$t('app.changeLanguage')"
              text
              v-on="on"
            >
              {{ $i18n.locale }}
              <!-- <v-icon class="ml-1 hidden-sm-and-down">
                mdi-translate
              </v-icon> -->
              <v-icon>
                mdi-chevron-down
              </v-icon>
            </v-btn>
          </template>
          <language-selector />
        </v-menu>
      </v-toolbar-items>
    </v-app-bar>
    <v-content>
      <v-fade-transition mode="out-in">
        <router-view :key="$route.fullPath" />
      </v-fade-transition>
    </v-content>
    <v-footer>
      <v-spacer />
      <div>
        &copy; {{ new Date().getFullYear() }}
        <a
          href="https://geobid.pl"
          rel="noopener"
        >GEOBID</a>
      </div>
    </v-footer>
  </v-app>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  components: {
    LanguageSelector: () => import('@/components/LanguageSelector.vue')
  },
  data: () => ({
    drawer: undefined,
    publicPath: process.env.BASE_URL,
    welcomeAudioPlaying: undefined,
    items: [
      { icon: 'mdi-home', text: 'app.home', to: 'home' },
      { icon: 'mdi-account-group', text: 'app.public', to: 'public' },
      { icon: 'mdi-lock', text: 'app.private', to: 'secure' },
      { icon: 'mdi-folder', text: 'app.catalog', to: 'eservices' },
      { icon: 'mdi-help-circle', text: 'app.manual', to: 'Manual' } // ,
      // { icon: 'mdi-application-import', text: 'app.form', href: 'https://czechowice.geoportal2.pl/map/osrodek/umowa.htm' }
    ]
  }),
  computed: {
    ...mapState('settings', {
      TERYT: state => state.TERYT
    }),
    welcomeAudio: function () {
      return new Audio(`${this.publicPath}api/locales/audio/${this.$i18n.locale}.mp3`)
    }
  },
  watch: {
    welcomeAudio () {
      if (typeof this.welcomeAudioPlaying !== 'undefined') {
        this.welcomeAudioPlaying.pause()
        this.welcomeAudioPlaying = undefined
      }
    }
  },
  created () {
    this.$vuetify.theme.dark = true
    this.loadGeoportals({ config: 'geoportals', filePath: `${this.publicPath}api/geoportals.json` })
    this.loadGeoportals({ config: 'gminy', filePath: `${this.publicPath}api/gminy.json` })
    this.loadSettings(`${this.publicPath}api/settings.json`)
  },
  methods: {
    ...mapActions(['loadGeoportals']),
    ...mapActions('settings', [
      'loadSettings' // -> this.loadSettings()
    ]),
    playWelcome: function () {
      if (typeof this.welcomeAudioPlaying === 'undefined' ||
        (this.welcomeAudioPlaying.paused && this.welcomeAudioPlaying.currentTime >= 0) ||
        this.welcomeAudioPlaying.ended) {
        this.welcomeAudioPlaying = this.welcomeAudio
        this.welcomeAudioPlaying.play()
      } else {
        this.welcomeAudioPlaying.pause()
      }
    }
  }
}
</script>

<style lang="sass">
  @import './style/main.sass'

  #app-toolbar
    .v-toolbar__title
      margin-left: .5em
</style>
